<template>
    <div class="data-card">
        <div class="data-card__title">{{ partner.title }}</div>
        <div v-if="partner.type" class="data-card__line">
            <v-icon small color="#ad282d">mdi-tag-outline</v-icon><span>{{ partner.type }}</span>
        </div>
        <div v-if="partner.address" class="data-card__line">
            <v-icon small color="#ad282d">mdi-map-marker-outline</v-icon><span>{{ partner.address }}</span>
        </div>
        <div class="data-card__line">
            <v-icon small color="#ad282d">mdi-calendar-outline</v-icon><span>Καταχωρήθηκε στις {{ getDate() }}</span>
        </div>
    </div>
</template>

<script>
    import { formatAthensDate } from '@/utils/date'
    export default {
        props: {
            partner: {
                type: Object,
                default: null
            }
        },
        data: () => {
            return {
            }
        },
        methods: {
            getDate() {
                return formatAthensDate(this.partner.createdAt)
            }
        }
    }
</script>

<style scoped>
.data-card {
    width: 100%;
    height: 100%;
    padding: 16px 18px;
    border: 1px solid rgba(27, 47, 90, 0.1);
    border-radius: 14px;
    background: #fff;
    color: #1b2f5a;
}
.data-card__title {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.35;
}
.data-card__amount {
    flex: 0 0 auto;
    color: #ad282d;
}
.data-card__line {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin-top: 6px;
    font-size: 14px;
    color: rgba(27, 47, 90, 0.75);
}
</style>
